import _ from 'lodash';
import moment from 'moment';

/**
 * Associatiave Filter
 *
 * Filters while retaining indexes.
 *
 * @param  {Function} callback
 * @return {array}
 */
Array.prototype.filterAssoc = function(callback) {
    var a = this.slice();
    a.map(function(v, k, a) {
        if(!callback(v, k, a)) delete a[k];
    });
    return a;
};

/**
 * @param arr
 * @param expression
 * @return {boolean}
 */
export const areAllTrue = (arr, expression) => arr.reduce((valid, value) => !valid ? valid : expression(value), true);

/**
 * Run a callback that returns a promise consecutively
 *
 * @param {[]} items
 * @param {function} cb
 */
export const promiseQueue = (items, cb) => {
    let itemList = _.cloneDeep(items);

    return cb(itemList.shift()).then(() => {
        if (itemList.length) {
            return promiseQueue(itemList, cb);
        }
        return true;
    });
};

/**
 * Convert a Date from Server.
 *
* @param  {} dateObj
* @return {}
 */
export const dateFromServer = (dateObj) => {
    let mDate;
    if (!dateObj) {
        return null;
    }
    if (typeof dateObj === 'string') {
        mDate = moment(dateObj, 'YYYY-MM-DD');
    }
    if (dateObj.date) {
        mDate = moment(dateObj.date, 'YYYY-MM-DD');
    }
    if (!mDate || !mDate.isValid()) {
        return null;
    }
    return mDate.format('DD/MM/YYYY');
};



// WEBPACK FOOTER //
// ./src/services/helper.js